/* global displayApprovalStatuses exportSupplierContractsToFile fetchUsersUrl supplierContractsIndexUrl supplierContractDeleteUrl supplierContractBulkDeleteUrl supplierContractTermsIndexUrl supplierContractTermStoreUrl */
/* global supplierContractTermUpdateUrl supplierContractTermDeleteUrl downloadSupplierContractsTermAttachmentUrl deleteSupplierContractsTermAttachmentUrl cancelPOUrl updateQuantitiesUrl eventStartDate eventEndDate isSupplierPortalEnabled */

import React, { useCallback, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import SupplierContractsIndexTable from './SupplierContractsIndexTable';

import { ConfirmationModalProvider } from 'Context/ConfirmationModalContext';
import { UsersProvider } from 'Context/UsersContext';

function SupplierContractsIndex({ updateSignedContractUrl, departmentsOptions, ownersOptions, isSupplierPortalEnabled }) {
    const [refreshKey, setRefreshKey] = useState(0);

    // Function to trigger a refresh
    const triggerRerender = useCallback(() => {
        setRefreshKey((prevKey) => prevKey + 1);
    }, []);

    return (
        <ConfirmationModalProvider>
            <div className="tw-flex tw-flex-col tw-gap-y-4">
                <SupplierContractsIndexTable
                    key={`contracts-${refreshKey}`} // Ensure rerender when refreshKey changes
                    forDeletedContracts={false}
                    exportToFile={exportSupplierContractsToFile}
                    supplierContractsIndexUrl={supplierContractsIndexUrl}
                    supplierContractDeleteUrl={supplierContractDeleteUrl}
                    supplierContractBulkDeleteUrl={supplierContractBulkDeleteUrl}
                    supplierContractTermsIndexUrl={supplierContractTermsIndexUrl}
                    supplierContractTermStoreUrl={supplierContractTermStoreUrl}
                    supplierContractTermUpdateUrl={supplierContractTermUpdateUrl}
                    supplierContractTermDeleteUrl={supplierContractTermDeleteUrl}
                    downloadSupplierContractsTermAttachmentUrl={downloadSupplierContractsTermAttachmentUrl}
                    deleteSupplierContractsTermAttachmentUrl={deleteSupplierContractsTermAttachmentUrl}
                    updateSignedContractUrl={updateSignedContractUrl}
                    cancelPOUrl={cancelPOUrl}
                    updateQuantitiesUrl={updateQuantitiesUrl}
                    displayApprovalStatuses={displayApprovalStatuses}
                    refreshContractTables={triggerRerender}
                    eventStartDate={eventStartDate}
                    eventEndDate={eventEndDate}
                    departmentsOptions={departmentsOptions}
                    ownersOptions={ownersOptions}
                    isSupplierPortalEnabled={isSupplierPortalEnabled}
                />

                <SupplierContractsIndexTable
                    key={`closed-contracts-${refreshKey}`} // Ensure rerender when refreshKey changes
                    forDeletedContracts={false}
                    forClosedContracts={true}
                    exportToFile={exportSupplierContractsToFile}
                    supplierContractsIndexUrl={supplierContractsIndexUrl}
                    supplierContractDeleteUrl={supplierContractDeleteUrl}
                    supplierContractBulkDeleteUrl={supplierContractBulkDeleteUrl}
                    supplierContractTermsIndexUrl={supplierContractTermsIndexUrl}
                    supplierContractTermStoreUrl={supplierContractTermStoreUrl}
                    supplierContractTermUpdateUrl={supplierContractTermUpdateUrl}
                    supplierContractTermDeleteUrl={supplierContractTermDeleteUrl}
                    downloadSupplierContractsTermAttachmentUrl={downloadSupplierContractsTermAttachmentUrl}
                    deleteSupplierContractsTermAttachmentUrl={deleteSupplierContractsTermAttachmentUrl}
                    updateSignedContractUrl={updateSignedContractUrl}
                    cancelPOUrl={cancelPOUrl}
                    updateQuantitiesUrl={updateQuantitiesUrl}
                    displayApprovalStatuses={displayApprovalStatuses}
                    refreshContractTables={triggerRerender}
                    eventStartDate={eventStartDate}
                    eventEndDate={eventEndDate}
                    departmentsOptions={departmentsOptions}
                    ownersOptions={ownersOptions}
                    isSupplierPortalEnabled={isSupplierPortalEnabled}
                />
            </div>
        </ConfirmationModalProvider>
    );
}

export default SupplierContractsIndex;
if (document.getElementById('SupplierContractsIndex')) {
    var rootEl = document.getElementById('SupplierContractsIndex');
    ReactDOM.render(
        <App>
            <UsersProvider fetchUrl={fetchUsersUrl}>
                <SupplierContractsIndex isSupplierPortalEnabled={isSupplierPortalEnabled} />
            </UsersProvider>
        </App>,
        rootEl,
    );
}
